import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["toggle"];

  toggle() {
    this.toggleTarget.classList.toggle("translate-x-5");
  }
}
